module.exports = __webpack_public_path__ + "images/canonical-card/alert-taco.c0c2af9001bc577cd570.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/canonical-card/alert-taco.svg
// module id = CXSo
// module chunks = 12